import _ from 'lodash'
import styled from 'styled-components'

import { Dictionary } from '../../utils/types'
import { Link } from '../Link'
import { Flex } from '../Flex'
import { themeColor, themeSpace } from '../theme'

export const BreadcrumbsContainer = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;

  padding: ${themeSpace(4)} 0 ${themeSpace(2)} 0;
`
BreadcrumbsContainer.displayName = 'BreadcrumbsContainer'

export const Breadcrumb = styled.li`
  display: block;
  a {
    color: ${themeColor('textPrimary')};
  }
`

Breadcrumb.displayName = 'Breadcrumb'

const Separator = styled.div`
  margin: 0 ${themeSpace(1)};
`

export interface BreadcrumbItem {
  text?: string
  link?: string
  query?: Dictionary<string>
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[]
}

export const Breadcrumbs = ({ items, ...rest }: BreadcrumbsProps) => {
  return (
    <BreadcrumbsContainer {...rest}>
      {_.map(items, (b, i) => (
        <Breadcrumb key={i}>
          <Flex>
            {b.link ? (
              <Link to={b.link} query={b.query}>
                {b.text}
              </Link>
            ) : (
              b.text
            )}
            {i !== items.length - 1 && <Separator>&gt;</Separator>}
          </Flex>
        </Breadcrumb>
      ))}
    </BreadcrumbsContainer>
  )
}
